{
  "title": "Entités non individuelles",
  "entityType": "Type d'entité",
  "typeOfTrust": "Type de fiducie",
  "natureOfBusiness": "Nature de l'activité",
  "entityName": "Nom de l'entité",
  "createNewNonIndividualEntity": "Mettre à jour l'entité non individuelle",
  "relationships": "Relations",
  "noRelationship": "Il n'y a pas de relations actuelles",
  "table": {
    "name": "Nom",
    "entityType": "Type d'entité",
    "primaryContact": "Contact principal",
    "suitabilityScore": "Score d'adéquation",
    "notCompleted": "Non finalisé",
    "completedAt": "Terminé à",
    "noOfAccounts": "Nombre de comptes",
    "totalAssets": "Total des actifs",
    "organization": "Organisation"
  },
  "editRelationship": "Mise à jour de la relation",
  "addRelationship": "Ajouter une nouvelle relation",
  "deleteRelationship": "Supprimer la relation",
  "selectExistingUsers": "Sélectionner des utilisateurs existants",
  "createNewUser": "Créer un nouvel utilisateur",
  "edit": {
    "relationshipTo": "Relation avec {{whom}}"
  },
  "remove": {
    "areYouSure": "Êtes-vous sûr de vouloir retirer {{removedWhoName}} du?",
    "thisWillNotDelete": "Cela ne supprimera pas les informations du {{removedWhoName}}, mais il ne sera plus associé à {{removedFromName}}.",
    "yesRemove": "Oui, retirer",
    "hasBeenRemoved": "Le client a été supprimé de la liste des entités apparentées"
  }
}
